export const COMMENT = 'rationaleComment';
